export default __webpack_public_path__ + "static/media/web3.c54395ca.png";